import React, { useEffect, useContext, useRef, memo } from "react"
import Box from "@material-ui/core/Box"
import Typography from "@material-ui/core/Typography"
import { makeStyles } from "@material-ui/core/styles"
import ProgressBarLine from "@/components/common/ProgressBarLine"
import AssessmentContext from "@/components/assessment/AssessmentContext"
import Button from "@material-ui/core/Button"

const useStyles = makeStyles((theme) => ({
    progressBarLineWrapper: {
        zIndex: 2,
        padding: theme.spacing(4, 2),
        background: theme.palette.sparcaLightGrey.secondary,
        position: "sticky",
        top: ({ headerHeight }) => {
            return headerHeight
        },
        "&.sticky": {
            position: "fixed",
            top: ({ headerHeight }) => {
                return headerHeight
            },
            zIndex: 2,
            width: "100%",
            marginTop: '64px'
        },
    },
    progressBarLineInnerWrapper: {
        maxWidth: "1200px",
        margin: "0 auto",
    },
    progressBarLineText: {
        color: "black",
    },
}))

const QuestionnaireProgress = memo((props) => {
    const { totalResponse, totalQuestion, assessmentContentWrapperElement } = props
    const { headerHeight, nextQuestionIndex } = useContext(AssessmentContext)
    const styleProps = {
        headerHeight,
    }
    const classes = useStyles(styleProps)
    const progressBarLineWrapper = useRef()
    useEffect(() => {
        const sticky = headerHeight
        const progressBarLineWrapperRef = progressBarLineWrapper.current
        const scrollCallBack = window.addEventListener("scroll", () => {
            if (window.pageYOffset > sticky) {
                progressBarLineWrapperRef.classList.add("sticky")
            } else {
                progressBarLineWrapperRef.classList.remove("sticky")
            }
        })
        return () => {
            window.removeEventListener("scroll", scrollCallBack)
        }
    }, [])
    const handleNextQuestion = () => {
        const targetScrollItem = assessmentContentWrapperElement.children[1].children[nextQuestionIndex - 1]
        const progressBarLineWrapperRef = progressBarLineWrapper.current
        const detectSticky = progressBarLineWrapperRef.classList.contains("sticky")
        if (targetScrollItem) {
            targetScrollItem.scrollIntoView(true)
            const scrolledY = window.scrollY
            if (scrolledY) {
                if (detectSticky) window.scroll(0, scrolledY - headerHeight - progressBarLineWrapperRef.getBoundingClientRect().height - 20)
                else {
                    window.scroll(0, scrolledY - headerHeight - progressBarLineWrapperRef.getBoundingClientRect().height * 2 - 20)
                }
            }
        }
    }
    return (
        <Box className={classes.progressBarLineWrapper} ref={progressBarLineWrapper}>
            <Box className={classes.progressBarLineInnerWrapper}>
                <ProgressBarLine progress={totalResponse} outOf={totalQuestion} />
                <Box>
                    <Typography variant="h6" className={classes.progressBarLineText} align="right">
                        {totalQuestion && totalResponse !== undefined ? `${totalResponse}/${totalQuestion}` : null}
                    </Typography>
                </Box>
                {totalResponse < totalQuestion && (
                    <Box align="right" mt={3}>
                        <Button onClick={handleNextQuestion} variant="contained" color="primary">
                            Next Question
                        </Button>
                    </Box>
                )}
            </Box>
        </Box>
    )
})

export default QuestionnaireProgress
